// extracted by mini-css-extract-plugin
export default {"nav_dropdown":"nav_profile_nav_dropdown__acu2d","profile_icon":"nav_profile_profile_icon__0bwcy"};